import { useHasScope } from '../../../accounts/accountsQueries.legacy';
import HubspotPlaylistsAdminList from './HubspotPlaylistsAdminList';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ApiError from '../../../../components/Errors/ApiError';
import { View } from 'foundations-components/components/View';
import { PageHeader } from '../../../header/components/PageHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubspotPlaylistsAdmin = () => {
  const {
    hasScope: hasPublicPlaylistsAdminScope
  } = useHasScope('academy-public-playlists-admin');
  if (!hasPublicPlaylistsAdminScope) {
    return /*#__PURE__*/_jsx(ApiError, {
      marker404: "HUBSPOT_PLAYLISTS_ADMIN_API_404"
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      subtitle: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.admin.subtitleHelpIcon"
          })
        }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.admin.subtitle"
        })]
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.admin.heading"
      })
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      marginInline: "auto",
      maxInlineSize: "1280px",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(HubspotPlaylistsAdminList, {})
    })]
  });
};
export default HubspotPlaylistsAdmin;